import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { ToolCallMessagePartComponent } from "@assistant-ui/react";
import { BookOpen, Loader2 } from "lucide-react";

export const GetChapterDetailsTool: ToolCallMessagePartComponent = ({
  result,
}) => {
  const isLoading = result === undefined;

  // Safe parsing of result
  const rawData = typeof result === 'string' ? JSON.parse(result) : result;
  const data = rawData?.data?.details || rawData?.data || rawData;

  if (isLoading) {
    return (
      <Card className="w-full my-4 border-primary/20 bg-card/50">
        <CardContent className="flex items-center gap-4 p-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
            <Loader2 className="h-5 w-5 text-primary animate-spin" />
          </div>
          <div className="space-y-1">
            <p className="font-medium text-sm">Fetching chapter details...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="w-full my-4 border overflow-hidden">
      <div className="flex flex-row items-center gap-2 py-3 px-4 bg-muted/30 border-b">
        <div className="bg-primary/10 p-1.5 rounded-full text-primary">
          <BookOpen className="h-4 w-4" />
        </div>
        <div className="flex flex-col flex-1">
          <CardTitle className="text-sm font-medium">
            Read Chapter: {typeof (data?.title || data?.name) === 'object' ? JSON.stringify(data?.title || data?.name) : (data?.title || data?.name || 'Untitled')}
          </CardTitle>
          <div className="flex items-center gap-2 mt-0.5">
            <Badge variant="outline" className="text-[10px] h-4 px-1">
              ID: {typeof data?.id === 'object' ? JSON.stringify(data?.id) : data?.id}
            </Badge>
            {data?.display_order && (
              <span className="text-[10px] text-muted-foreground">
                Order: {typeof data.display_order === 'object' ? JSON.stringify(data.display_order) : data.display_order}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="p-0">
        <Accordion type="single" collapsible className="w-full" defaultValue="details">
          <AccordionItem value="details" className="border-0 px-4">
            <AccordionTrigger className="hover:no-underline py-2 text-xs text-muted-foreground">
              View Content
            </AccordionTrigger>
            <AccordionContent className="pb-4">
              <div className="text-sm text-foreground leading-relaxed max-h-[300px] overflow-y-auto whitespace-pre-wrap">
                {(() => {
                  const content = data?.description || data?.content;
                  if (!content) return <em className="text-muted-foreground">No content available</em>;
                  if (typeof content === 'object') return JSON.stringify(content, null, 2);
                  return content;
                })()}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </Card>
  );
};
